import angular from 'angular'
import statisticsModalCtrl from './statisticsModalCtrl'

import { rollout } from 'redevConfig'

const list = (rollout && rollout.list) || ''

const rolloutListPage = list ? require(`redevelopment/input/rollout/${list.templateName}`) : require('./view/rolloutList.html')
const rolloutListCtrl = list ? require(`redevelopment/input/rollout/${list.controllerName}`) : require('./rolloutListCtrl')
export default angular
    .module('input.inputInvoice.rollout', []).config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('input.inputInvoice.rollout', {
                url: '/rollout',
                abstract: true,
                template: '<div ui-view></div>',
                default: 'input.inputInvoice.rollout.list',
                title: '进项转出',
            })
            .state('input.inputInvoice.rollout.list', {
                url: '/list',
                template: rolloutListPage,
                controller: 'rolloutListCtrl',

            })
    }])
    .controller('rolloutListCtrl', rolloutListCtrl.default)
    .controller('statisticsModalCtrl', statisticsModalCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/rollout/index.js